import { CognitoAuth } from 'amazon-cognito-auth-js';
import elpPathService from './elpPathService';

export default class AwsCognitoService {
    auth = null;
    authConfig = null;
    identityProvider = null;
    mspTenantId = '';

    constructor(identityProvider, mspTenantId){
        this.setAuthObj(identityProvider, mspTenantId);
    }

    setAuthObj(identityProvider, mspTenantId){
        this.identityProvider = identityProvider;
        this.mspTenantId = mspTenantId;

        this.authConfig = {
            ClientId: identityProvider.clientAppId,
            AppWebDomain: identityProvider.appWebDomain,
            TokenScopesArray: [],
            RedirectUriSignIn: elpPathService.getConstituentSignInPath(),
            RedirectUriSignOut: elpPathService.getConstituentSignOutPath()
        }
        
        this.auth = new CognitoAuth(this.authConfig);
        this.auth.setState(this.mspTenantId);
    }

    signIn(){
        if(this.auth){
            const URL = this.auth.getFQDNSignIn();
            this.auth.launchUri(URL);
        }
    }
}


// WEBPACK FOOTER //
// ./src/common/awsCognitoService.js